import CommitteeMission from "./CommitteeMission";
import WhyCommittee from "./WhyCommittee";
import ContentSection from "./ContentSection";
import AdditionalResources from "./AdditionalResources";
import CTABanner from "./CTABanner";
import StatsSection from "./StatSection";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { committeeActions } from "../../../_store/committee.slice";
import { useLocation, useParams } from "react-router-dom";
import CustomLoader from "../../../components/common/ui/Loader";

function CommitteeLandingPage() {
  const dispatch = useDispatch();
  const { state } = useLocation();
  // const { id } = useParams();
  // console.log(id);
  const { loading } = useSelector((x) => x.committee);
  const isLoggedin = JSON.parse(sessionStorage.getItem("isLoggedIn"));

  const { committeeID } = useParams();
  debugger;
  const committeeData = state?.committeeID;

  useEffect(() => {
    if (!committeeID) return;
    dispatch(
      committeeActions?.getCommitteeHomePageIntegrationData(committeeID)
    );
    dispatch(committeeActions?.setCommittieID(committeeData));
  }, [committeeID]);

  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "instant",
    });
  }, []);

  if (loading) return <CustomLoader />;
  return (
    <>
     
      <CommitteeMission />
      <WhyCommittee />
      <ContentSection />
      {committeeData?.committeeName !== "Mind Body Resiliency Coalition" &&
        committeeData?.committeeName !== "Justice Project of South Florida" && (
          <StatsSection />
        )}
      {/* <AdditionalResources /> */}
      {(isLoggedin === false || isLoggedin === null) && <CTABanner />}
    </>
  );
}

export default CommitteeLandingPage;
